import {Injectable, inject} from '@angular/core'
import {Distributor} from '@models/distributor'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {DistributorService} from './distributor.service'

/**
 * Variante embebida de `DistributorService`.
 *
 * @description
 * En modo embebido, los distribuidores no provienen de PouchDB sino del payload que la
 * aplicación anfitriona puso en `EmbeddedStoreService.distributors`. Además, el filtrado
 * por organización se hace usando `embeddedIdComercial` (valor convencional `'EMBEDDED'`)
 * en lugar de `apiService.getIdComercial()`.
 */
@Injectable({
  providedIn: 'root',
})
export class DistributorEmbeddedService extends DistributorService {
  private readonly embeddedStoreService: EmbeddedStoreService = inject(EmbeddedStoreService)

  override getDistributors = async (): Promise<Distributor[]> => {
    return this.embeddedStoreService.distributors()
  }

  override getDistributorsById = async (distributorsId: string[]): Promise<Distributor[]> =>
    this.embeddedStoreService.distributors().filter(d => distributorsId.includes(d.id))

  override preGetDistributors = async (): Promise<void> => {
    if (!this.distributors.length) {
      this.distributors = await this.getDistributors()
    }
  }

  override getDistributorsForOrder = async (outletId: string): Promise<Distributor[]> => {
    const ids =
      this.outletService.outletRelationCodes[outletId] ?
        (Object.keys(this.outletService.outletRelationCodes[outletId]) ?? [])
      : []

    return this.getDistributors().then(distributors => {
      if (ids.length > 0) {
        return distributors
          ?.map(d => ({
            ...d,
            hasCode: ids.includes(d?.id?.toString()),
          }))
          ?.filter(
            d =>
              d?.attributes?.orders?.includes(this.embeddedStoreService.embeddedIdComercial) &&
              d?.attributes?.street?.includes(this.embeddedStoreService.embeddedIdComercial)
          )
      }
      return distributors
    })
  }
}
